import React from 'react'

function Kardex() {
  return (
    <div>Kardex</div>
  )
}

export default Kardex